<template>
    <div ref="navigation" id="navigation-account">
        <div class="navigation-account__content d-flex align-items-end flex-column">
            <span
                id="navigation-account__close-nav"
                class="d-block d-lx-none d-lg-none w-100 icon-hover__path-fill--blue link-gray__hover-blue cursor-pointer px-2 py-2"
                @click="responsiveCloseNav()"
            >
                <small class="font-weight-bold mr-1">{{ $t('close') }}</small>
                <iconClose />
            </span>

            <div class="navigation-account__club-logo d-block w-100">
                <router-link
                    :to="{ name: $options.ROUTES_HOME }"
                    @click.native="responsiveCloseNav"
                    class="navigation-account__club-logo-link d-block"
                >
                    <selected-club-info />
                </router-link>
            </div>

            <navigation-menu-content :responsive-close-nav="responsiveCloseNav" />

            <navigation-menu-footer />
        </div>
    </div>
</template>

<script>
import { ROUTES_HOME } from '@/constants/routes';
import { LudumEventBus, OPEN_NAVIGATION, CLOSE_NAVIGATION } from '@/event-bus';
import NavigationMenuContent from './NavigationMenuContent.vue';
import NavigationMenuFooter from './NavigationMenuFooter.vue';
import SelectedClubInfo from '@/components/navigation/SelectedClubInfo.vue';
import iconClose from '@/assets/img/account/close.svg?inline';

export default {
    ROUTES_HOME,

    components: {
        NavigationMenuContent,
        NavigationMenuFooter,
        SelectedClubInfo,
        iconClose
    },

    mounted() {
        LudumEventBus.$on(OPEN_NAVIGATION, () => {
            this.responsiveOpenNav();
        });
        LudumEventBus.$on(CLOSE_NAVIGATION, () => {
            this.responsiveCloseNav();
        });
    },

    beforeDestroy() {
        LudumEventBus.$off(OPEN_NAVIGATION);
        LudumEventBus.$off(CLOSE_NAVIGATION);
    },

    methods: {
        responsiveCloseNav() {
            this.$nextTick(() => {
                if (this.$refs.navigation) {
                    this.$refs.navigation.classList.remove('is-open-nav');
                }
            });
        },

        responsiveOpenNav() {
            this.$nextTick(() => {
                if (this.$refs.navigation) {
                    this.$refs.navigation.classList.add('is-open-nav');
                }
            });
        }
    }
};
</script>
